import type { WorldLevel } from '@/queries/constants'

import getWorldType from './getWorldType'
import type { WorldType } from './types'

const DEFAULT_TITLES = {
  member: 'Learner',
  tutor: 'Tutor',
  'senior-tutor': 'Senior Tutor',
  coach: 'Coach',
  moderator: 'Moderator',
}

const WORLD_TYPE_TO_TITLES: Record<WorldType, Record<WorldLevel, string>> = {
  academic: DEFAULT_TITLES,
  'non-academic': {
    member: 'Member',
    tutor: 'Host',
    'senior-tutor': 'Senior Host',
    coach: 'Coach',
    moderator: 'Moderator',
  },
  'sat-bootcamp': DEFAULT_TITLES,
  'school-partnership': DEFAULT_TITLES,
}

export default function getWorldLevelTitle({
  worldSlug,
  level,
  plural = false,
}: {
  worldSlug?: string
  level: WorldLevel
  plural?: boolean
}): string {
  const worldType = worldSlug == null ? 'academic' : getWorldType({ worldSlug })
  const titleFromType = WORLD_TYPE_TO_TITLES[worldType][level]

  if (!plural) {
    return titleFromType
  }
  return level === 'coach' ? 'Coaches' : `${titleFromType}s`
}
